import React, { useState } from 'react';
import { Card, Typography, Divider, Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import FormTitle from '../../../FormFields/FormTitle';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import FormTextField from '../../../FormFields/FormTextField';
import { formCardStyle } from '../../../TransitionStyles';
import { DIETARY } from '../../../formQuestionsEnum';
import { FILE_TYPES } from '../../../formFileTypesEnum';

CurrentMenuSystemForm.propTypes = {
  permissions: PropTypes.object,
};

export default function CurrentMenuSystemForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);
  const { watch } = useFormContext();

  const fieldIds = [DIETARY.CURRENT_MENU_SYSTEM.id, DIETARY.CURRENT_MENU_SYSTEM_CONTRACT.id];
  const isOutsourced = watch(DIETARY.DIETARY_IS_OUTSOURCED.fieldName);

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    isOutsourced === false &&
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Current menu system
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {DIETARY.CURRENT_MENU_SYSTEM.id in permissions && (
            <Grid item xs={12}>
              <FormTextField
                fieldName={DIETARY.CURRENT_MENU_SYSTEM.fieldName}
                fieldAttributes={{
                  isEditable: permissions[DIETARY.CURRENT_MENU_SYSTEM.id],
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}

          {DIETARY.CURRENT_MENU_SYSTEM_CONTRACT.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Upload contract', fieldType: 'file' }} />
              <FormFileDrop
                fieldName={DIETARY.CURRENT_MENU_SYSTEM_CONTRACT.fieldName}
                fieldAttributes={{
                  isEditable: permissions[DIETARY.CURRENT_MENU_SYSTEM_CONTRACT.id],
                  fileTypeId: FILE_TYPES.CURRENT_MENU_SYSTEM_CONTRACT,
                }}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
